import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { GeometriesListComponent } from "./geometries-list.component";

@NgModule({
    imports: [
        RaskCommonModule,
        GeometriesListComponent
    ],
    exports: [GeometriesListComponent]
})
export class GeometriesListModule { }
